if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      
      this.quantityElement = this.querySelector('.quantity-input');
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      

      if(this.classList.contains('main-product-grid')){
        this.currentMediaSize = 'large';

        this.titleToMove = this.querySelector('.title-to-move');
        this.descriptionToMove = this.querySelector('.description-to-move');

        this.titleTarget = this.querySelector('.title-target');
        this.titleTargetLarge = this.querySelector('.title-target-large');

        this.descriptionTarget = this.querySelector('.description-target');
        this.descriptionTargetLarge = this.querySelector('.description-target-large');

        this.largeGalleryTarget = this.querySelector('.gallery-target-large');

        window.addEventListener('mediaChange', ()=> { this.handleMediaChange()});
        this.handleMediaChange();
      }
    }

    handleMediaChange(){
      if($s.media.isLarge && this.currentMediaSize != 'large') {
        this.currentMediaSize = 'large';
        this.titleTargetLarge.append(this.titleToMove);
        this.descriptionTargetLarge.append(this.descriptionToMove);

      } 
      if($s.media.isMediumDown && this.currentMediaSize != 'medium') {
        this.currentMediaSize = 'medium';
        this.titleTarget.append(this.titleToMove);
        this.descriptionTarget.append(this.descriptionToMove);
      }
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }

  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.normalizeCardImages()
      this.addEventListener('lazyloaded', (event) => {
        if (event.target?.classList?.contains('img')) {
          this.normalizeCardImages()
        }
      }, true)
      this.swatches = this.querySelector('.swatch-group');
      this.mainElement = this.closest('.product-main-element');
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.buttonGroup = this.querySelector('.atc-btn-group');
      this.expand = this.classList.contains('.expand');
      this.formElement = this.querySelector('.atc-options-wrapper form');

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          self.colorSwatches = self.querySelector('product-swatch.color-swatches');
          if (self.colorSwatches) {
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin',self.colorSwatches);
          }
        }, 10);
      }

      if(this.buttonGroup){
        setTimeout(() => {        
          var subscribeButton = self.querySelector('.subscribe-button')
          var otpButton = self.querySelector('.otp-button')
          // var subscribeLabel = self.querySelector(`[for="plan-option-${self.mainElement.sectionId}"]`)
          var subscribeLabel = self.querySelector(`.subscription-group label`)
          var otpLabel = self.querySelector(`[for="plan-option-onetime-${self.mainElement.sectionId}"]`)
          var submitButton = self.querySelector(`[type="submit"]`)
          var informationIcon = self.querySelector('.information-icon')
          if(informationIcon){             
              informationIcon.addEventListener('click', (e)=>{
                e.preventDefault();
                informationIcon.classList.toggle('open')
              })
          }
          self.querySelectorAll('.atc-btn-group button').forEach((button) => {
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              var currentTarget = e.target.tagName == 'BUTTON' ? e.target : e.target.closest('button');
              if(subscribeLabel && currentTarget === subscribeButton){
                subscribeLabel.click();
                submitButton.click();
              } else if(currentTarget === otpButton){
                if (otpLabel) {
                  otpLabel.click();
                  submitButton.click(); 
                } else {
                  submitButton.click();
                }
              }
              $s.removeTrapFocus(this.formElement);           
            })
          })
        }, 100);
      }

      if(this.expand){
        const closeOptions = () =>{
          this.formElement.classList.remove("expanded");
          $s.removeTrapFocus(this.formElement);
          document.removeEventListener('click', outsideClickListener);
          this.removeEventListener('keydown', onEscape);
        }
    
        const onEscape = (e) =>{
          if (e.key === "Escape") {
            closeOptions();
          }
        }
    
        const outsideClickListener = evt => {
          if (!this.formElement.contains(evt.target) && this.formElement !== evt.target ) {
            closeOptions();
          }
        }
  
        var optionButton = this.querySelector('.atc-options.btn');
         
        if(optionButton){
          optionButton.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            
            this.formElement.classList.add("expanded");
            $s.trapFocus(this.formElement);     
            document.addEventListener('click', outsideClickListener);
            this.addEventListener('keydown',onEscape)
          });
        }
      }
    }

    onVariantChange(event) {
      var image = event.detail.variant.featured_image;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

    }

    normalizeCardImages() {
      this.querySelectorAll('img').forEach((image) => {
        const role = (image.getAttribute('role') || '').toLowerCase();
        if (role === 'presentation' || role === 'none') {
          image.removeAttribute('role');
        }
        const alt = (image.getAttribute('alt') || '').trim();
        if (!alt) {
          const link = image.closest('.product-card-url');
          const linkLabel = link ? (link.getAttribute('aria-label') || '').trim() : '';
          if (linkLabel) {
            image.setAttribute('alt', linkLabel);
          }
        }
      });
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add').style.display = '';
          document.querySelector('.input-and-btn .quantity-input') ? document.querySelector('.input-and-btn .quantity-input').style.display = '' : '';
          this.querySelector('.sold-out-message').style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          document.querySelector('.input-and-btn .quantity-input') ? document.querySelector('.input-and-btn .quantity-input').style.display = 'none' : '';
          this.querySelector('.sold-out-message').style.display = '';
      	}
      });
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector(':scope > div');
      this.desktopStyle = this.dataset.desktop;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key);
              if(optionIndex>=0) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.itemsWrapper.querySelectorAll('[data-media-id]').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('[data-media-id]'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
        if(variant.featured_media) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('[data-media-id]').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 1) +'px)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && this.desktopStyle=='carousel' )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('[data-media-id]').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: true,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dealElement = this.querySelector('.deal');
      this.retailElement = this.querySelector('.retail');

      ['variantChange','quantityChange','sellingPlanChange'].forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = e.detail.variant || e.detail.sellingPlan;
          if(!data) {
            data = this.mainElement.getCurrentVariant();
          }
        	if(data) {
            var price = 0;
            if(document.querySelectorAll('.cross-sell.upsell').length > 0){
              document.querySelectorAll('.cross-sell.upsell').forEach(function(e){
                price += parseFloat(e.querySelector('.hidden-price').innerHTML);
              })
              var newPrice = data.price + price;
              this.dealElement.innerHTML = $s.formatMoney(newPrice * this.mainElement.getQuantity());
            }else{
              this.dealElement.innerHTML = $s.formatMoney(data.price * this.mainElement.getQuantity());
            }
 
        		

            if(data.compare_at_price > data.price) {
              this.retailElement.classList.remove('hide');
              this.retailElement.innerHTML = $s.formatMoney(data.compare_at_price * this.mainElement.getQuantity());
            } else {
              this.retailElement.classList.add('hide');
              this.retailElement.innerHTML = '';
            }
        	} else {
        		this.dealElement.innerHTML = '';
            this.retailElement.innerHTML = '';
        	}
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantInput = this.querySelector('[data-variant-id]');

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
      }, 10);
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));
    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.mainElement.querySelectorAll('[data-option]').forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;

      this.buildOptionSelector();
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
  		var html = `
  			<div class="option-name">${this.label}: <span class="option-value">${defaultValue}</span></div>
  			<div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
  			html += `
          <div class="swatch" data-available="${option.available}">
            <input type="radio" id="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}" value="${option.value}" />
  				  <label for="swatch-${this.optionNumber}-${option.value}-${this.mainElement.sectionId}">
              <div class="label-inner ${optionNameHandle}-${optionValueHandle}">
              	<span>${option.value}</span>
              </div>
            </label>
          </div>
  			`;
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

  		if(defaultValue && group.querySelector('input[value="'+defaultValue+'"]')) {
  			group.querySelector('input[value="'+defaultValue+'"]').checked = true;
  		} else {
  			group.querySelector('input').checked = true;
  		}
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;

      this.buildOptionSelector();
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name" for="${optionId}">${this.label}</label>
        <select id="${optionId}"></select>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? ' - Sold Out' : '');
  			html += `<option value="${option.value}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}
/*
REF: FEATURE PICKUP AVAILABILITY
if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('product-main');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('button');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'test');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}
*/



//REF: FEATURE SELLING PLANS
if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();
      var self = this;
      this.mainElement = this.closest('.product-main-element');
      this.input = this.querySelector('[data-selling-plan-id]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textOnetime = this.dataset.textOnetime || "One-Time Purchase";
      this.textSubscribe = this.dataset.textSubscribe || "Subscribe";
      this.textSubscribeSave = this.dataset.textSubscribesave || "Subscribe \u0026 Save";
      this.onlyFirst = this.dataset.onlyFirst === '1' ? true : false;
      this.onlyOTP = false;


      this.oldRecharge = false;
      if (this.mainElement.productData.sellingPlanGroups[0].original_to_hidden_variant_map) {
        this.mainElement.querySelector('[data-variant-id]').removeAttribute('name');
        this.rechargeVariantElement = this.mainElement.querySelector('[data-recharge-variant-id]');
        this.subscriptionUnitElement = this.querySelector('[name="properties[shipping_interval_unit_type]"]')
        this.subscriptionIdElement = this.querySelector('[name="properties[subscription_id]"]')
        var group = this.mainElement.productData.sellingPlanGroups[0];
        var map = group.original_to_hidden_variant_map;
        var frequencies = group.frequencies;
        this.oldRecharge = true;
        this.mainElement.productData.variants.forEach(function(variant) {
          variant.selling_plan_allocations = [];
          frequencies.forEach(function(frequency) {
            if(map[variant.id]){
              variant.selling_plan_allocations.push({
                "compare_at_price": variant.price,
                "per_delivery_price": map[variant.id].discount_variant_price * 100,
                "price": map[variant.id].discount_variant_price * 100,
                "price_adjustments": [
                  {
                    "position": 1,
                    "price": map[variant.id].discount_variant_price * 100
                  }
                ],
                "selling_plan_group_id": 1,
                "selling_plan_id": frequency
              });
            } else if (group){
              self.onlyOTP = true;
            }

          });

        });
      }

      this.input.addEventListener('change', ()=>{
        this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
      });

      if(self.onlyOTP) {
        self.mainElement.querySelectorAll('.only-subscription').forEach((item) => {
          item.style.display = 'none'
        })
      }
      
      ['variantChange','quantityChange'].forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          this.groupsContainer.innerHTML = !self.onlyOTP ? this.getGroupsHtml() : '';
          this.plansContainer = this.querySelector('[data-plans]');  //obtained newly generated element
          var groupInputs = this.groupsContainer.querySelectorAll('[name="purchase_option"]');        

          groupInputs.forEach((groupInput)=>{

            groupInput.addEventListener('change', (radioEvent)=>{

              groupInputs.forEach((radioElement)=>{
                if(radioElement != radioEvent.target )
                  radioElement.parentElement.classList.remove('active');
                else
                  radioElement.parentElement.classList.add('active');
              });

              var plan = this.plansContainer.querySelector('select');
              //get html with same plan name currently selected
              this.plansContainer.innerHTML = this.getPlansHtml(plan?plan.options[plan.selectedIndex].text : '');

              //only get the select if enabled, otherwise clear selling_plan input value
              var select = this.plansContainer.querySelector('select.enabled');
              if(select) {
                select.addEventListener('change', (e)=>{
                  this.updateSellingPlan(e.target.value);
                });

                if(select.querySelector('option[value="'+this.input.value+'"]')) {
                  select.value = this.input.value;
                }
                select.dispatchEvent(new Event('change', {bubbles: true}));
              } else {
                this.updateSellingPlan("");
              }
            });
          });

          var currentPlan = this.getCurrentPlan();
          if(currentPlan) {
            var groupInput = this.groupsContainer.querySelector('[value="'+currentPlan.selling_plan_group_id+'"]');
          } else {
            var groupInput = this.groupsContainer.querySelector('[name="purchase_option"][value=""]');
          }
          groupInput.checked = true;
          groupInput.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
      
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      if (this.oldRecharge) {
        var variantId = this.mainElement.getCurrentVariant().id;
        if (sellingPlanId) {
          this.input.setAttribute('name', 'properties[shipping_interval_frequency]');
          this.subscriptionUnitElement.setAttribute('name', 'properties[shipping_interval_unit_type]');
          this.subscriptionIdElement.setAttribute('name', 'properties[subscription_id]');
          var map = this.mainElement.productData.sellingPlanGroups[0].original_to_hidden_variant_map
          this.rechargeVariantElement.value = map[variantId].discount_variant_id;
        } else {
          this.input.removeAttribute('name');
          this.subscriptionUnitElement.removeAttribute('name');
          this.subscriptionIdElement.removeAttribute('name');
          this.rechargeVariantElement.value = variantId;
        }
      } else {
        if (sellingPlanId) {
          this.inputFrequencyName.value = this.getCurrentGroup().selling_plans.find(x=>x.id==sellingPlanId).options[0].value;
        } else {
          this.inputFrequencyName.value = ''
        }
      }

      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    getGroupsHtml() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var html = '';

      if(currentVariant) {
        this.mainElement.productData.sellingPlanGroups.forEach((group)=>{
          let priceAdjustment = group.selling_plans[0].price_adjustments;
          let discount = (priceAdjustment && priceAdjustment.length > 0 ? priceAdjustment[0].value : 0); // expected percentage
          let planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_group_id==group.id);
          if(planAlloc) {
            let optionId = `plan-option-${group.id}-${this.mainElement.sectionId}`;
            let optionPrice = $s.formatMoney(planAlloc.price * 1).replace('.00', '');
            html += `
              <div class="sub-option subscription-group" data-group="${group.id}">
                <input type="radio" name="purchase_option" value="${group.id}" id="${optionId}">
                <label for="${optionId}">` + (discount ? this.textSubscribeSave + ' <span class="option-discount">'+Math.floor(discount)+'%</span>' : this.textSubscribe) + ` <span class="option-price">${optionPrice}</span></label>
                <div data-plans></div>
              </div>
            `;
          }
        });
      }

      if(!this.mainElement.productData.requiresSellingPlan) {
        let optionId = `plan-option-onetime-${this.mainElement.sectionId}`;
        let optionPrice = $s.formatMoney(currentVariant.price * 1);
        html += `
          <div class="sub-option">
            <input type="radio" name="purchase_option" value="" id="${optionId}">
            <label for="${optionId}">${this.textOnetime} <span class="option-price">${optionPrice}</span></label>
          </div>
        `;
      }
      
      
      
      return html;
    }

    getPlansHtml(selectedName) {
      //functionalities:
      // show or hide frequency dropdown when the One-Time option is selected
      // show a div with the frequency option when there is a single option but keep the <select> hidden
      //
      var currentVariant = this.mainElement.getCurrentVariant();
      var enabled = true;
      var currentGroup = this.getCurrentGroup();
      if (!currentGroup) {
        
        currentGroup = this.mainElement.productData.sellingPlanGroups[0];
        
        enabled = false;
      }
      var html = '';

      if(currentGroup) {
        var isOneOption = this.onlyFirst || currentVariant.selling_plan_allocations.length == 1;

        selectedName = selectedName.trim();
        html = '<div class="flex align-content-start"><label class="select-label ' + (isOneOption ? 'hide' : '') + '">Deliver every:</label>'
        html += '<select class="' + (enabled ? 'enabled' : '') +'" ' + (enabled ? '' : 'disabled="disabled"') + '>';
        currentVariant.selling_plan_allocations.forEach((plan)=>{
          var sellingPlan = currentGroup.selling_plans.find(x=>x.id==plan.selling_plan_id);
          var sellingPlanSuffix = (+(((sellingPlan.options?.[1]?.value ?? '')).match(/^\d+(?:\.\d+)?/)?.[0] ?? 0) > 1 ? 's' : '');
          html += `<option value="${sellingPlan.id}"  `+ (selectedName==sellingPlan.options[1].value.trim() ? 'selected="selected"' : '')+`>${sellingPlan.options[1].value+sellingPlanSuffix}</option>`;
        });
        html += `</select> </div>`;

        html += "<div class='sub-checklist hide'>"
        html += "<div class='flex align-items-center check-elmt'> <div class='check-blue'></div><span>Free Shipping</span> </div>"
        html += "<div class='flex align-items-center check-elmt'> <div class='check-blue'></div><span>Cancel Anytime</span> </div>"
        html += "<div class='flex align-items-center check-elmt'> <div class='check-blue'></div><span>Change, Pause, Skip</span> </div>"
        html += "</div>"

        if (isOneOption) {
          html += `<div class="selling-plan-name">${currentGroup.selling_plans[0].name}</div>`;
        }
      }

      return html;
    }

    getCurrentPlan() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if(currentVariant) {
        return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
      }
      return false;
    }

    getCurrentGroup() {
      var groupId = this.querySelector('[name="purchase_option"]:checked').value;
      return this.mainElement.productData.sellingPlanGroups.find(x=>x.id==groupId);
    }
  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}
